import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../../_services/message.service';


import { User } from '../../_models/user';
import { Globals } from '../../_globals/globals';
import {Reason} from '../../_models/reason';
import {ReasonType} from '../../_models/reason_type';


@Injectable({
  providedIn: 'root'
})

export class ReasonService {

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {}

  getReasons(searchParams): Observable<Reason[]> {

    console.log('-->--> Ejecutando servicio getReason');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Reason[]>(this.globals.apiUrl + '/reason', options)
      .pipe(
        tap(  _ => this.log('get reason')),
        catchError(this.handleError<Reason[]>('getReason', null)
      ));
  }

  getReasonTypes(searchParams): Observable<ReasonType[]> {

    console.log('-->--> Ejecutando servicio getReasonTypes');
    console.log(searchParams);
    console.log('---------------');

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: searchParams };

    return this.http.get<ReasonType[]>(this.globals.apiUrl + '/reasonType', options)
      .pipe(
        tap(  _ => this.log('get reason type')),
        catchError(this.handleError<ReasonType[]>('getReasonTypes', null)
      ));

  }

  updateReason(reasonIn: Reason): Observable<Reason> {

    console.log('-->--> Ejecutando servicio updateReason');
    console.log(reasonIn);
    console.log('---------------');

    let options = {};
    if (reasonIn.id === null) {
      options = { params: new HttpParams()
        .set('id', '0') };
    } else {
      options = { params: new HttpParams()
        .set('id', reasonIn.id.toString()) };
    }

    return this.http.put<Reason>(this.globals.apiUrl + '/reason', reasonIn, options)
      .pipe(
        tap(  _ => this.log('updated reason')),
        catchError(this.handleError<Reason>('updateReason', null)
      ));
  }

  createReason(reasonIn: Reason): Observable<Reason> {

    console.log('-->--> Ejecutando servicio createReason');
    console.log(reasonIn);
    console.log('---------------');

    const options = {};

    return this.http.post<Reason>(this.globals.apiUrl + '/reason', reasonIn, options)
      .pipe(
        tap(  _ => this.log('created reason')),
        catchError(this.handleError<Reason>('createReason', null)
      ));
  } // End function createReason

  deleteReason(reasonIn: Reason): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteReason');
    console.log(reasonIn);
    console.log('---------------');

    let options = { params: new HttpParams()
        .set('id', reasonIn.id.toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/reason', options)
      .pipe(
        tap(  _ => this.log('deleted reason')),
        catchError(this.handleError<bigint>('deleteReason', null)
      ));
  } // End function deleteReason

  // Servicio para obtener los agentes comerciales.
  getUsers(): Observable<User[]> {

    console.log('-->--> Ejecutando servicio getUsers');

    return this.http.get<User[]>(this.globals.apiUrl + '/users')
      .pipe(
        tap( data => console.log(' -> Comerciales obtenidos desde getUsers.')),
        catchError(this.handleError<User[]>('getUsers', [])
      ));
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }

  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
